<template>
    <v-row justify="center">
        <v-dialog
            v-model="planDialog"
            :persistent='true'
            width="38%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle title="プラン一覧" />
                        <div>
                            <v-data-table
                                :items="desserts"
                                :headers="headers"
                                hide-default-footer
                                disable-pagination
                                >
                                <template v-slot:[`item.detail`]="{ item }">
                                    <v-btn color="green darken-4" small text @click="openExplanationPlan(item)">詳細</v-btn>
                                </template>
                                <template v-slot:[`item.select`]="{ item }">
                                    <v-btn color="green darken-4" small text @click="timeDialogOpen(item)">選択</v-btn>
                                </template>
                                <template></template>
                            </v-data-table>
                        </div>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="closeModal">閉じる</v-btn>
                        </v-card-actions>
                    <ExplanationPlanTable
                        ref="ExplanationModal"
                        />
                    <StartTimeSelect
                        ref="StartTimeModal"
                        :received="passTo"
                        :childDialog="timeDialog"
                        @success="successClose($event)"
                        @close="closeModal"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import ExplanationPlanTable from './ExplanationPlanTable';
import { GET_PLAN_CELL_LIST } from '@/constants/plan';
import StartTimeSelect from './StartTimeSelect';
import { CODE_MASTER } from '../../config';
import { utilityMixin } from '@/mixins/utility';

export default {
    components: {
        CardTitle,
        StartTimeSelect,
        ExplanationPlanTable
    },
    mixins: [utilityMixin],
    props: {
        received: {
            type: Object,
            require: true
        },
        planDialog: Boolean
    },
    data () {
        return {
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            explanationDialog: false,
            timeDialog: false,
            desserts: [],
            cellNumber: 1,
            noSelect: 1,
            passTo: {
                cellId: '',
                planId: '',
                golfCode: '',
                reserveType: '',
                playDate: '',
                memberNo: '',
                memberClass: '0',
                cellIdList: [],
                groupInfo: []
            },
            headers: [
                { text: '連携ID', value: 'plan_id', sortable: false, width: '10%' },
                { text: 'プラン名', value: 'plan_name', sortable: false, width: '50%' },
                { text: '', value: 'detail', sortable: false, width: '10%' },
                { text: '', value: 'select', sortable: false, width: '10%' }
            ]
        };
    },
    methods: {
        /** ----------------------------------------------
         * 検索画面の検索ボタン押下
         * 条件に応じたプランを取得し、表示する。
         * ---------------------------------------------- */
        getPlan (startDate) {
            const startDateStr = this.getDateStr(startDate);
            // プラン検索
            this.$apollo.query({
                query: GET_PLAN_CELL_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: this.golfGroupCode,
                    cell_number: this.cellNumber,
                    golf_code: this.received.golfCode,
                    member_no: this.received.memberNo,
                    play_date_from: startDateStr,
                    play_date_to: startDateStr,
                    price_max_code: this.noSelect,
                    price_min_code: this.noSelect,
                    benefit_codes: [],
                    start_times_codes: [],
                    style_codes: []
                }
            }).then(res => {
                const tmp = res.data.getPlanCellList.PlanCellList;
                const plans = this.addReserveType(tmp);
                this.desserts = this.planFilter(plans, this.received.reserveType);
                this.$store.commit('loading/setIsLoading', false);
            }).catch(error => {
                const message = error.message.split(':');
                this.message = message;
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** ----------------------------------------------
         * 取得したプランにreserveTypeを追加する
         * ---------------------------------------------- */
        addReserveType (array) {
            return array.map(el => {
                // リクエスト不可の場合
                if (el.request_flag === 0) {
                    // シェア不可の場合
                    if (el.share_flag === 0) {
                        el['reserveType'] = Number(CODE_MASTER.RESERVE_TYPE_NORMAL);
                    } else {
                        el['reserveType'] = Number(CODE_MASTER.RESERVE_TYPE_SHARE);
                    }
                } else {
                    el['reserveType'] = Number(CODE_MASTER.RESERVE_TYPE_REQUEST);
                }
                return el;
            });
        },
        /** ----------------------------------------------
         * プランをreseveTypeでソートする
         * ---------------------------------------------- */
        planFilter (plans, reserveType) {
            let filterPlans;
            // シェア可能なプランに絞る
            if (reserveType === Number(CODE_MASTER.RESERVE_TYPE_SHARE)) {
                filterPlans = plans.filter(plan => plan.reserveType === Number(CODE_MASTER.RESERVE_TYPE_SHARE));
                filterPlans = filterPlans.filter(filterPlans => filterPlans.reserve_status >= 1);
                filterPlans = filterPlans.filter(filterPlans => filterPlans.reserve_status <= 2);
                filterPlans = filterPlans.filter((element, index, self) => self.findIndex(e => e.plan_id === element.plan_id) === index);
            // リクエスト予約ではないものに絞る
            } else if (reserveType === Number(CODE_MASTER.RESERVE_TYPE_REQUEST)) {
                // filterPlans = plans.filter(plan => plan.reserveType !== Number(CODE_MASTER.RESERVE_TYPE_REQUEST));
                filterPlans = plans.filter(plan => plan.plan_id === this.received.planId);
            // 通常予約可能なプランに絞る(シェア可のプランも他の予約がなければ選択可とする)
            } else {
                filterPlans = plans.filter(plan => plan.reserveType === Number(CODE_MASTER.RESERVE_TYPE_NORMAL));
                filterPlans = filterPlans.filter(filterPlans => filterPlans.reserve_status >= 1);
                filterPlans = filterPlans.filter(filterPlans => (filterPlans.reserve_status <= 2));
                // 重複データを省く
                filterPlans = filterPlans.filter((element, index, self) => self.findIndex(e => e.plan_id === element.plan_id) === index);
            }
            return filterPlans;
        },
        /** ----------------------------------------------
         * プラン詳細画面を表示する
         * ---------------------------------------------- */
        openExplanationPlan (item) {
            this.$refs.ExplanationModal.ModalControl(item.golf_code, item.plan_id, this.received.playDate);
        },
        /** ----------------------------------------------
         * 人数選択画面を表示する
         * ---------------------------------------------- */
        timeDialogOpen (item) {
            const planId = item.plan_id;
            const request = item.request_flag;
            const share = item.share_flag;
            var oldPlanId = this.passTo.planId;
            this.passTo.planId = planId;

            let reserveType = 0;
            if (request === 0) {
                if (share === 0) {
                    reserveType = 1;
                } else {
                    reserveType = 2;
                }
            } else {
                reserveType = 3;
            }

            this.planId = planId;
            this.reserveType = reserveType;
            this.passTo.reserveType = reserveType;
            this.timeDialog = true;
            this.$refs.StartTimeModal.ModalControl(this.planId, this.passTo.playDate, reserveType, this.passTo.groupInfo, oldPlanId);
        },
        /** ----------------------------------------------
         * この画面を開く処理
         * ---------------------------------------------- */
        ModalControl (groupInfo) {
            this.passTo.cellId = this.received.cellId;
            this.passTo.planId = this.received.planId;
            this.passTo.planName = this.received.planName;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.golfCode = this.received.golfCode;
            this.passTo.reserveNo = this.received.reserveNo;
            this.passTo.playDate = this.received.playDate;
            this.passTo.memberNo = this.received.memberNo;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.memberClass = this.received.memberClass;
            this.passTo.cellIdList.push({ cellId: this.received.cellId, number: this.received.playNumber });
            this.passTo.groupInfo = groupInfo;
            this.getPlan(this.passTo.playDate);
        },
        /** ----------------------------------------------
         * 人数選択画面で正常終了した際に走る処理
         * ---------------------------------------------- */
        successClose (reserveNo) {
            this.desserts = [];
            this.timeDialog = false;
            this.$emit('success', reserveNo);
        },
        /** ----------------------------------------------
         * この画面を閉じる処理
         * ---------------------------------------------- */
        closeModal () {
            this.desserts = [];
            this.timeDialog = false;
            this.$emit('close');
        }
    }
};
</script>
